import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { SphereAppCategory } from '../../../constants/app-categories';

type AppSwitcherStore = {
    selectedCategory: SphereAppCategory | 'favorites' | null;
};

const initialState: AppSwitcherStore = {
    selectedCategory: null
};

export const AppSwitcherStore = signalStore(
    withState(initialState),
    withMethods(store => ({
        selectCategory(category: SphereAppCategory | 'favorites') {
            patchState(store, { selectedCategory: category });
        }
    }))
);
